import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import {LeadButtonTerms} from "./LeadButtonTerms";
import {LeadRodoTerms} from "./LeadRodoTerms";

interface IProps {
    isSending: boolean;
    buttonText: string;
}

export const FormSubmitFooter = (props: IProps) => {
    const {isSending, buttonText} = props;

    return (
        <>
            <Button type="submit" variant="filled_primary" fullWidth className={css({mb: 1})} disabled={isSending} isLoading={isSending}>
                {buttonText}
            </Button>

            <LeadButtonTerms as="p" buttonText={buttonText} color="initial" mb={1} />

            <LeadRodoTerms as="p" linkText="Więcej" color="initial" linkClassName={css({fontWeight: "bold"})} />
        </>
    );
};
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import {LeadButtonTerms} from "./LeadButtonTerms";
import {LeadRodoTerms} from "./LeadRodoTerms";

interface IProps {
    isSending: boolean;
    buttonText: string;
}

export const FormSubmitFooter = (props: IProps) => {
    const {isSending, buttonText} = props;

    return (
        <>
            <Button type="submit" variant="filled_primary" fullWidth className={css({mb: 1})} disabled={isSending} isLoading={isSending}>
                {buttonText}
            </Button>

            <LeadButtonTerms as="p" buttonText={buttonText} color="initial" mb={1} />

            <LeadRodoTerms as="p" linkText="Więcej" color="initial" linkClassName={css({fontWeight: "bold"})} />
        </>
    );
};
